import {Chip} from "@mui/material";
import {isVitrayaInternalUser} from "./UserAuth";

export let TariffTableColumn = [
    {
        title: "Master Category",
        field: "master_category",
        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.master_category && (
                <p
                    style={{
                        width: !isVitrayaInternalUser() ? "160px" : "100px",
                    }}
                >
                    {rowData.master_category}
                </p>
            ),
    },
    {
        title: "Bill Line Item",
        field: "bill_line_item",
        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.bill_line_item && (
                <p
                    style={{
                        width: isVitrayaInternalUser() ? "200px" : "300px",
                        overflow: "auto",
                    }}
                >
                    {rowData.bill_line_item}
                </p>
            ),
    },
    {
        title: "IRDAI Payable",
        field: "irdai_payable",
        sorting: true,
        align: "center",
        render: (rowData) => {
            const isPayable = rowData.irdai_payable === true;

            return (
                <Chip
                    label={isPayable ? "Payable" : "Non-Payable"}
                    color={isPayable ? "success" : "error"}
                    variant="outlined"
                    style={{padding: 2}}
                />
            );
        },
    },

    {
        title: "Procedure Construct Payable",
        field: "procedure_construct_payable_text",
        align: "center",
        sorting: true,
        render: (rowData) => {
            const shortForm = {
                "Payable by Procedure Construct": "Payable",
                "Partially Payable by Procedure Construct": "Partially Payable",
                "Non-Payable by Procedure Construct": "Non-Payable",
            };

            const procedureConstructPayable =
                rowData.procedure_construct_payable_text;

            return (
                <Chip
                    label={
                        shortForm[procedureConstructPayable] || procedureConstructPayable
                    }
                    color={
                        {
                            "Payable by Procedure Construct": "success",
                            "Partially Payable by Procedure Construct": "primary",
                        }[procedureConstructPayable] || "error"
                    }
                    variant="outlined"
                    style={{padding: 2}}
                />
            );
        },
    },

    {
        title: "Tariff Application Text",
        field: "tariff_application_reference_text",
        align: "center",
        sorting: true,
        render: (rowData) =>
            rowData &&
            rowData.tariff_application_reference_text &&
            isVitrayaInternalUser() && (
                <p
                    style={{
                        width: isVitrayaInternalUser() ? "160px" : "80px",
                        overflow: "auto",
                    }}
                >
                    {rowData.tariff_application_reference_text}
                </p>
            ),
    },
    {
        title: "Unit",
        field: "unit",
        align: "right",
    },
    {
        title: "Unit Amount",
        field: "unit_amount",
        align: "right",
        render: (rowData) =>
            rowData.unit_amount && (
                <p> &#x20b9; {Math.trunc(rowData.unit_amount * 100) / 100}</p>
            ),
    },
    {
        title: "Total Bill Amount",
        field: "total_bill_amount",
        align: "right",
        render: (rowData) =>
            // rowData.total_bill_amount &&
            rowData.total_bill_amount > rowData.admissible_amount &&
            Math.trunc(rowData.savings) > 0 ? (
                <b>&#x20b9; {Math.trunc(rowData.total_bill_amount * 100) / 100}</b>
            ) : (
                <p>&#x20b9; {Math.trunc(rowData.total_bill_amount * 100) / 100}</p>
            ),
    },

    {
        title: "Tariff Rate",
        field: "tariff_rate",
        align: "right",
        render: (rowData) =>
            // rowData.tariff_rate &&
            rowData.total_bill_amount > rowData.admissible_amount &&
            Math.trunc(rowData.savings) > 0 ? (
                <b>&#x20b9; {Math.trunc(rowData.tariff_rate * 100) / 100}</b>
            ) : (
                <p>&#x20b9; {Math.trunc(rowData.tariff_rate * 100) / 100}</p>
            ),
    },
    {
        title: "Tariff Amount",
        field: "admissible_amount",
        align: "right",
        render: (rowData) =>
            // rowData.admissible_amount &&
            rowData.total_bill_amount > rowData.admissible_amount &&
            Math.trunc(rowData.savings) > 0 ? (
                <b>&#x20b9; {Math.trunc(rowData.admissible_amount * 100) / 100}</b>
            ) : (
                <p>&#x20b9; {Math.trunc(rowData.admissible_amount * 100) / 100}</p>
            ),
    },
    {
        title: "Savings",
        field: "savings",
        align: "right",
        render: (rowData) =>
            rowData.total_bill_amount > rowData.admissible_amount &&
            Math.trunc(rowData.savings) > 0 ? (
                <b>&#x20b9; {Math.trunc(rowData.savings * 100) / 100}</b>
            ) : (
                <p>&#x20b9; {Math.trunc(rowData.savings * 100) / 100}</p>
            ),
    },
];
